/**
 * Logo component — ComplianceOS brand V2.
 *
 * Image variants are served as <img> from /brand/ (ADR-S9-002): each SVG is an
 * isolated document, swap = replace the file.
 *
 * The "wordmark" variant is a COMPOSITE (S11): a clean gradient mark <img> next
 * to the wordmark rendered as real HTML text in the app font (Outfit). Reason:
 * an SVG loaded via <img> cannot use the page's webfonts, so SVG <text> falls
 * back to a system font (wrong font + unpredictable width → clipping). HTML text
 * always uses the loaded webfont, never clips, scales with font-size, and keeps
 * "OS" in the brand cyan. White text — render it on a dark surface (navy header,
 * or a navy chip in light contexts like the app sidebar).
 *
 * Variants:
 *   "wordmark" — mark + "ComplianceOS" HTML text (navbar / sidebar expanded). Size via text-* class.
 *   "mark"     — clean gradient isotipo, no circuits (sidebar collapsed, small contexts). Size via w/h class.
 *   "symbol"   — white isotipo (legacy)
 *   "inverse"  — horizontal white-on-dark SVG with "by MSSPRD" (footer / documents)
 *   "horizontal" / "gradient" — light backgrounds / empty states
 */

const SRCS = {
  symbol:     "/brand/complianceos-symbol-white.svg",
  inverse:    "/brand/complianceos-logo-inverse.svg",
  horizontal: "/brand/complianceos-logo-horizontal.svg",
  gradient:   "/brand/complianceos-symbol-gradient.svg",
  mark:       "/brand/complianceos-mark.svg",
};

const Logo = ({ variant = "inverse", className = "", alt = "ComplianceOS", ...props }) => {
  if (variant === "wordmark") {
    return (
      <span
        className={`inline-flex items-center gap-2 leading-none ${className}`}
        role="img"
        aria-label={alt}
        {...props}
      >
        <img
          src={SRCS.mark}
          alt=""
          aria-hidden="true"
          draggable={false}
          className="h-[1.05em] w-auto shrink-0"
        />
        <span className="font-heading font-extrabold tracking-tight whitespace-nowrap">
          <span className="text-white">Compliance</span>
          <span className="text-[#00D4FF]">OS</span>
        </span>
      </span>
    );
  }

  const src = SRCS[variant] ?? SRCS.inverse;
  return (
    <img src={src} alt={alt} className={className} draggable={false} {...props} />
  );
};

export default Logo;
